import lightStyle from '@repo/assets/map_styles/light.json';
import darkStyle from '@repo/assets/map_styles/dark.json';
import { mapId } from '../firebase';

/** What Live's map and the zones map share: an HTML element on the map, and Google's map in the app's own style. */

export type LL = google.maps.LatLngLiteral;
export const ll = (p: { lat: number; lng: number }): LL => ({ lat: p.lat, lng: p.lng });

/** An HTML element on the map at a position (the app's plates and discs). */
export interface HtmlOverlay {
  overlay: google.maps.OverlayView;
  el: HTMLDivElement;
  move(p: LL): void;
}

export function makeHtml(map: google.maps.Map, pos: LL, el: HTMLDivElement, z: number): HtmlOverlay {
  let at = pos;
  class Html extends google.maps.OverlayView {
    onAdd() {
      this.getPanes()!.overlayMouseTarget.appendChild(el);
    }
    draw() {
      const p = this.getProjection()?.fromLatLngToDivPixel(new google.maps.LatLng(at.lat, at.lng));
      if (p) {
        el.style.left = `${p.x}px`;
        el.style.top = `${p.y}px`;
      }
    }
    onRemove() {
      el.remove();
    }
  }
  el.style.zIndex = String(z);
  google.maps.OverlayView.preventMapHitsAndGesturesFrom(el);
  const o = new Html();
  o.setMap(map);
  return {
    overlay: o,
    el,
    move(p) {
      at = p;
      o.draw();
    },
  };
}

export const icon = (name: string) => `<svg class="i" aria-hidden="true"><use href="#i-${name}"/></svg>`;
export const escape = (s: string) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]!);

/** Google's map as Routr draws it: no Google buttons, greedy gestures, the app's own style (or the map ID's). */
export function mapOptions(theme: 'light' | 'dark'): google.maps.MapOptions {
  return {
    center: { lat: 9.07, lng: 7.475 },
    zoom: 13,
    disableDefaultUI: true,
    gestureHandling: 'greedy',
    clickableIcons: false,
    backgroundColor: 'transparent',
    ...(mapId ? { mapId } : { styles: theme === 'dark' ? darkStyle : lightStyle }),
  };
}

export const styleFor = (theme: 'light' | 'dark') => (theme === 'dark' ? darkStyle : lightStyle);
